import React, { useState, useEffect } from "react";
import { Card, Box } from "@mui/material";
import Input from "@mui/material/Input";
import InputLabel from "@mui/material/InputLabel";
import InputAdornment from "@mui/material/InputAdornment";
import FormControl from "@mui/material/FormControl";
import SearchSharpIcon from "@mui/icons-material/SearchSharp";

import { getobj } from "../../apicall/apicall";
import { headerStyle, searchStyle, boxStyle } from "../../style/style";
import ReplacedDeviceList from "../ReplacedDeviceList";
import ViewDetails from "../Dialogs/ViewDetails";
import ReplaceDevices from "../Dialogs/ReplaceDevice";

export default function ReplaceDevice() {
  const [page, setPage] = useState(1);
  const [devices, setDevices] = useState([]);
  const [loader, setLoader] = useState(true);
  const [totalPage, setTotalPage] = useState(1);
  const [search, setSearch] = useState("");
  const [loadData, setLoadData] = useState(false);
  const [openEditModal, setOpenEditModal] = useState(false);
  const [openViewModal, setOpenViewModal] = useState(false);
  const [selectedDevice, setSelectedDevice] = useState(null);

  useEffect(() => {
    const getDevices = async () => {
      let url;
      setLoader(true);
      if (search === "") {
        url =
          process.env.REACT_APP_ZEWA_URL +
          "replace-device/devices/?page=" +
          page;
      } else {
        setPage(1);
        url =
          process.env.REACT_APP_ZEWA_URL +
          "replace-device/devices/?page=1&search=" +
          search;
      }

      const res = await getobj(url);
      setDevices(res.results);
      if (res.results.length > 0) {
        if (res.count % 5 > 0) {
          setTotalPage(Math.floor(res.count / 5) + 1);
        } else {
          setTotalPage(Math.floor(res.count / 5));
        }
      }
      setLoader(false);
    };

    getDevices();
  }, [page, loadData, search]);

  const handleSearch = (e) => {
    e.preventDefault();
    setLoadData(!loadData);
  };
  //
  return (
    <div>
      <Card sx={boxStyle}>
        <Card sx={headerStyle}>
          Replace Device
          <form onSubmit={handleSearch} style={searchStyle}>
            <FormControl variant="standard" sx={searchStyle}>
              <InputLabel htmlFor="input-with-icon-adornment">
                Search Device
              </InputLabel>
              <Input
                id="input-with-icon-adornment"
                startAdornment={
                  <InputAdornment position="start">
                    <SearchSharpIcon color="primary" />
                  </InputAdornment>
                }
                value={search}
                onInput={(e) => {
                  setSearch(e.target.value);
                  if (e.target.value === "") {
                    handleSearch(e);
                  }
                }}
                //onChange={handlesearch}
              />
            </FormControl>
          </form>
        </Card>
      </Card>
      {loader ? (
        <Box sx={boxStyle}>
          <Card sx={headerStyle}>
            <img src="https://zewa-logo-bucket.s3.amazonaws.com/logo/Spinner-1s-200px.gif" alt="loading..." />
          </Card>
        </Box>
      ) : devices.length > 0 ? (
        <Box style={boxStyle}>
          <ReplacedDeviceList
            devices={devices}
            page={page}
            setPage={setPage}
            totalPage={totalPage}
            openEditModal={openEditModal}
            setOpenEditModal={setOpenEditModal}
            openViewModal={openViewModal}
            setOpenViewModal={setOpenViewModal}
            setSelectedDevice={setSelectedDevice}
          />
        </Box>
      ) : (
        <Box sx={boxStyle}>
          <Card sx={headerStyle}>No Replaced Device Found</Card>
        </Box>
      )}
      {openEditModal && (
        <ReplaceDevices
          open={openEditModal}
          setOpen={setOpenEditModal}
          selectedDevice={selectedDevice}
          setLoadData={setLoadData}
          loadData={loadData}
        />
      )}
      {openViewModal && (
        <ViewDetails
          open={openViewModal}
          setOpen={setOpenViewModal}
          selectedDevice={selectedDevice}
        />
      )}
    </div>
  );
}
